module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc6.a64285d4.png";